module.exports = "/virtual-football-league/img/games-table-odds.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/games-table-odds.png
// module id = 329
// module chunks = 4